<template>
  <v-card
    class="elevation-2 mx-auto mt-6"
    max-width="600"
  >
    <v-card-title class="headline d-flex align-center">
      <v-icon
        class="mr-3"
        color="orange"
        size="32"
      >
        lock
      </v-icon>
      {{ title }}
    </v-card-title>

    <v-divider />

    <v-card-text class="pt-4 pb-6">
      <v-row>
        <v-col>
          <p class="font-weight-medium mb-3">
            {{ message }}
          </p>

          <p class="text--secondary mb-4">
            {{ details }}
          </p>

          <div class="d-flex align-center text--secondary">
            <v-icon
              class="mr-2"
              color="grey"
              size="18"
            >
              info
            </v-icon>
            <span class="caption">
              Need help?
              <a
                class="font-weight-medium"
                href="mailto:tech@oao.freshdesk.com"
                target="_blank"
              >
                Contact support
              </a>
            </span>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'AccessDeniedCard',

  props: {
    title: {
      type: String,
      default: 'Access Denied',
    },
    message: {
      type: String,
      default: 'You don\'t have permission to access this resource.',
    },
    details: {
      type: String,
      default: 'Please contact your administrator if you believe you should have access.',
    },
  },
}
</script>

<style lang="scss" scoped>
.v-card {
  border-radius: 8px;
}

.headline {
  color: #424242;
}

a {
  text-decoration: none;
  color: #1976d2;

  &:hover {
    text-decoration: underline;
  }
}
</style>
